import React, { CSSProperties, useLayoutEffect, useRef } from "react";

interface IRichTextProps {
  html: string;
  tag: "h1" | "p";
  style: CSSProperties;
  editable: boolean;
  pathKey: string;
  onFocus: () => void;
  onChange: (html: string) => void;
}

// contentEditable text of a heading / paragraph. The HTML is written into the DOM only while the
// element isn't being typed in - re-setting it on every keystroke would move the caret to the start.
const RichText = ({ html, tag, style, editable, pathKey, onFocus, onChange }: IRichTextProps) => {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (element && document.activeElement !== element && element.innerHTML !== html) {
      element.innerHTML = html;
    }
  }, [html]);

  return React.createElement(tag, {
    ref,
    style: { ...style, outline: "none", cursor: editable ? "text" : "inherit" },
    contentEditable: editable,
    suppressContentEditableWarning: true,
    "data-rich-text": pathKey,
    onFocus,
    onInput: (e: React.FormEvent<HTMLElement>) => onChange(e.currentTarget.innerHTML),
  });
};

export default RichText;
